import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React, { useCallback, useState } from "react";
import PopupDialog from "../../Form/PopupDialog";
import { Dialog } from "./DialogProvider";
import SettingsTextField from "../../Settings/Old/Form/SettingsTextField";

interface Props {
    title: string;
    label: string;
    question: string;
    acceptButtonTitle?: string;
    cancelButtonTitle?: string;
    testId?: string;
}

const useStyles = makeStyles({
    question: {
        marginBottom: "1rem"
    }
});

const TextInputDialog: Dialog<string, Props> = props => {
    const classes = useStyles();

    const {
        onCancel,
        onAccept,
        title,
        label,
        question,
        acceptButtonTitle,
        cancelButtonTitle
    } = props;

    const [text, setText] = useState("");

    const onAcceptClicked = useCallback(() => {
        onAccept(text);
    }, [onAccept, text]);

    return (
        <PopupDialog
            open
            onSecond={onCancel}
            onFirst={onAcceptClicked}
            firstTitle={acceptButtonTitle ?? "Bestätigen"}
            secondTitle={cancelButtonTitle ?? "Abbrechen"}
            title={title}>

            <Typography
                variant="body1"
                className={classes.question}>
                {question}
            </Typography>

            <SettingsTextField
                label={label}
                value={text}
                onChanged={setText} />

        </PopupDialog>
    );
};

export default TextInputDialog;
